import styled from 'styled-components';

import AuthModal from '../Shared/AuthModal';
import Footer from '../Shared/NewFooter';
import Header from '../Shared/NewHeader';
import Search from '../Shared/NewHeader/Search';

import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { saveEmails } from '../../firebase/venues';
import { useEmailTag } from '../../tag-manager/email';
import EmailModal, { EMAIL_MODAL_PHOTO } from '../Shared/AuthModal/EmailModal';
import { bodyStyles, mobile } from '../styles';

// H2: 2 hero files. A tall screen only shows the middle of a wide photo, so
// it gets a tall cut centred on the tree; everything else gets the whole photo.
// public/index.html preloads the same 2 files with the SAME media query.
// If the two differ, the browser downloads both. Made by
// scripts/make-hero-images.py; a new photo needs a new file name (-v2).
const Background = styled.div`
  ${bodyStyles}
  background-image: url(/img/home-hero-desktop-v1.webp);
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  @media (max-aspect-ratio: 3/4) {
    background-image: url(/img/home-hero-phone-v1.webp);
  }
`;

// AEO-7a: <main> so an extraction model knows where the page content starts.
// It was a plain div. The tag changed, the CSS did not.
const SearchWrapper = styled.main`
  max-width: 661px;
  margin: 0 auto;
  padding: 200px 21px;
  box-sizing: border-box;

  @media (max-width: ${mobile}) {
    padding: 120px 21px;
    height: calc(100vh - 133px);
  }
`;

// AEO-7a: the one <h1> for "/". The homepage stays visually minimal by
// decision, so this is read by engines and screen readers, not seen.
// `position: absolute` takes it out of the layout flow, so it moves nothing.
// Wording is the approved HOME_TITLE without the brand name, because an <h1>
// describes the page, not the company. Source: yedding-brain/BRAND-CONTEXT.md §1.
const PageHeading = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
  white-space: nowrap;
  clip-path: inset(50%);
`;

// After a person closes the popup, hide it in every tab for this long.
const EMAIL_MODAL_HIDE_MS = 24 * 60 * 60 * 1000;

function Home() {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailThanks, setEmailThanks] = useState(false);

  useEffect(() => {
    const userJoined = localStorage.getItem('userJoinedTheList') === 'true';
    const showModalJoinTheList = sessionStorage.getItem('showModalJoinTheList') === 'true';
    const closedAt = Number(localStorage.getItem('emailModalClosedAt')) || 0;

    if (userJoined || Date.now() - closedAt < EMAIL_MODAL_HIDE_MS) {
      return;
    }

    if (!showModalJoinTheList) {
      // Open the popup only when its photo is ready, so photo and text show
      // together. Wait at least 1 s; give up for this visit after 6 s.
      let cancelled = false;
      const photo = new Image();
      photo.src = EMAIL_MODAL_PHOTO;
      const photoReady = photo.decode().catch(() => {});
      const minWait = new Promise((resolve) => setTimeout(resolve, 1000));
      const giveUp = setTimeout(() => (cancelled = true), 6000);

      Promise.all([photoReady, minWait]).then(() => {
        if (cancelled) return;
        clearTimeout(giveUp);
        setShowEmailModal(true);
        sessionStorage.setItem('showModalJoinTheList', 'true');
      });

      return () => {
        cancelled = true;
        clearTimeout(giveUp);
      };
    }
  }, []);

  const onClose = () => {
    localStorage.setItem('emailModalClosedAt', String(Date.now()));
    setShowEmailModal(false);
  };

  const handleJoin = async (email) => {
    try {
      useEmailTag({ email });
      localStorage.setItem('userJoinedTheList', 'true');
      await saveEmails(email);

      setShowEmailModal(false);
      console.log('Save email in Firestore successfully');
    } catch (error) {
      toast.error('An error occurred while saving your email.😓');
      console.error('Error joining the list:', error);
    }
  };

  return (
    <Background>
      <Header omitSearch />
      <SearchWrapper>
        <PageHeading>Unique wedding and event venues you can rent by the day</PageHeading>
        <Search />
      </SearchWrapper>
      <Footer />
      <AuthModal />
      <Modal
        centered
        show={showEmailModal}
        onHide={onClose}
        className={emailThanks ? 'email-modal-thanks' : undefined}
        dialogClassName={emailThanks ? 'custom-email-modal is-thanks' : 'custom-email-modal'}
        backdropClassName={emailThanks ? 'email-backdrop-thanks' : undefined}
      >
        <EmailModal onCloseClick={onClose} onJoin={handleJoin} onThanks={() => setEmailThanks(true)} />
      </Modal>
    </Background>
  );
}

export default Home;
